<template>
  <el-dialog
    :visible.sync="visible"
    @update:visible="onClose"
    :width="width"
    :show-close="false"
    :before-close="onClose"
    @close="onClose"
    center
  >
    <el-row v-loading="isLoading">
      <div v-if="showClose" :class="removeCloseBtnSpace ? 'remove-close-btn-space' : ''" >
        <i class="el-icon-close custom-icon-close" @click="onClose"></i>
      </div>
      <slot />
    </el-row>
    <template #footer>
      <slot name="footer" />
    </template>
  </el-dialog>
</template>

<script>
export default {
  props: {
    visible: Boolean,
    isLoading: Boolean,
    showClose: Boolean,
    removeCloseBtnSpace: Boolean,
    width: String,
  },
  methods: {
    onClose() {
      this.$emit("update:visible", false);
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.remove-close-btn-space {
  margin-bottom: -26px;
}

.custom-icon-close {
  padding: 12px;
  margin: -12px;
  width: 24px;
  height: 24px;
  font-size: 24px;
  font-weight: 600;
  color: #828282;
}
</style>